<div>
  <button class="btn btn-outline-primary btn-sm" (click)="whenClicked($event)" type="button">
    <i class="fa fa-refresh" aria-hidden="true"></i>
    Reset
  </button>
</div>